module.exports = __webpack_public_path__ + "static/media/Shopify.ee59e907.svg";